// src/App.js
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Skills from "./components/Skills";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Hero from "./components/hero";
import Navbar from "./components/navbar";
import Footer from "./components/Contact";
import CustomCursor from "./components/CustomCursor";
import CommandPalette from "./components/CommandPalette";
import BuildingPage from "./pages/BuildingPage";
import { ThemeProvider } from "./context/ThemeContext";

function MainPage({ onOpenCmd, setCmdOpen, cmdOpen }) {
  return (
    <>
      <CustomCursor />
      <div className="flex flex-col min-h-screen overflow-x-hidden">
        <Navbar onOpenCmd={() => setCmdOpen(true)} />
        <main className="flex-grow relative">
          <section id="hero"><Hero /></section>
          <section id="about"><About /></section>
          <section id="portfolio"><Portfolio /></section>
          <section id="skills"><Skills /></section>
        </main>
        <Footer />
      </div>
      <CommandPalette isOpen={cmdOpen} onClose={() => setCmdOpen(false)} />
    </>
  );
}

function App() {
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        setCmdOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <CustomCursor />
        <Routes>
          <Route
            path="/"
            element={<MainPage setCmdOpen={setCmdOpen} cmdOpen={cmdOpen} />}
          />
          <Route path="/building" element={<BuildingPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
